import { combineReducers } from 'redux';
import revisionIndexReducer from './revisionIndex/reducer';
import AlgorithmParametersSharedState from './AlgorithmParametersSharedState';

export const algorithmParametersSharedStateReducer =
    combineReducers<AlgorithmParametersSharedState>({
        revisionIndex: revisionIndexReducer,
    });
